// extracted by mini-css-extract-plugin
export default {"bountyItem":"bounty-item_bountyItem__QYfnU","selected":"bounty-item_selected__D10Sa"};